import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from './environments/environment';

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
